import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import BottomNav from './components/BottomNav';
import ReminderPopup from './components/ReminderPopup';
import DemoBanner from './components/DemoBanner';
import { useReminderPoll } from './hooks/useReminderPoll';
import { useAuth } from './context/AuthContext';
import Home from './pages/Home';
import Medicines from './pages/Medicines';
import AddMedicine from './pages/AddMedicine';
import Records from './pages/Records';
import Settings from './pages/Settings';
import Login from './pages/Login';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading">加载中...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppContent() {
  const { user } = useAuth();
  const { activeReminder, snoozeCount, confirmReminder, snoozeReminder } = useReminderPoll(!!user);
  const activeMedicine = activeReminder
    ? { name: activeReminder.medicine_name, dosage: activeReminder.dosage, unit: activeReminder.unit, notes: activeReminder.notes }
    : null;

  // 演示版同样要求登录：数据按账号隔离，一个账号一份数据。
  // 但登录页提供「一键体验演示账号」，所以并不会给访问者制造门槛。
  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <>
      <DemoBanner />
      <Routes>
        <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
        <Route path="/medicines" element={<ProtectedRoute><Medicines /></ProtectedRoute>} />
        <Route path="/medicines/add" element={<ProtectedRoute><AddMedicine /></ProtectedRoute>} />
        <Route path="/medicines/edit/:id" element={<ProtectedRoute><AddMedicine /></ProtectedRoute>} />
        <Route path="/records" element={<ProtectedRoute><Records /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
        <Route path="/login" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <BottomNav />
      <ReminderPopup
        reminder={activeReminder}
        medicine={activeMedicine}
        onConfirm={confirmReminder}
        onSnooze={snoozeReminder}
        snoozeCount={snoozeCount}
      />
    </>
  );
}

// AuthProvider / SettingsProvider / VoiceProvider 在 index.js 中统一挂载
export default function App() {
  return (
    <HashRouter>
      <AppContent />
    </HashRouter>
  );
}
